import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '@/config/api';

/** Live catalog counts. Never invent a fallback number. */
export function dash(value) {
  if (value === null || value === undefined || value === '') return '-';
  return value;
}

export default function useCatalogStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_BASE}/stats`)
      .then((res) => {
        const data = res.data;
        const usable = data && typeof data === 'object' && !Array.isArray(data) ? data : null;
        if (!cancelled) setStats(usable);
      })
      .catch(() => {
        if (!cancelled) setStats(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return stats;
}
